import { authClient } from './client';
import extractErrorMessage from '../utils/extractErrorMessage';

// Items of every protocol category, diseases included.
const protocolSubcategoryApi = {
  getAll: async (page = 1, limit = 10, { category, searchTerm, isActive, ids } = {}) => {
    try {
      const params = { page, limit };
      if (ids?.length) params.ids = ids.join(',');
      if (category) params.category = category;
      if (searchTerm) params.searchTerm = searchTerm;
      if (isActive !== undefined && isActive !== null) params.isActive = isActive;
      return (await authClient.get('/protocol-subcategories', { params })).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  getById: async (id) => {
    try {
      return (await authClient.get(`/protocol-subcategories/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  create: async (payload) => {
    try {
      return (await authClient.post('/protocol-subcategories', payload)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  update: async (id, payload) => {
    try {
      return (await authClient.patch(`/protocol-subcategories/${id}`, payload)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },

  remove: async (id) => {
    try {
      return (await authClient.delete(`/protocol-subcategories/${id}`)).data;
    } catch (error) {
      return { data: null, success: false, message: extractErrorMessage(error, 'Došlo je do greške') };
    }
  },
};

export default protocolSubcategoryApi;
